export interface ErrorAws {
    code: AwsAuthErrorCodes;
}

export enum AwsAuthErrorCodes {
    LimitExceededException = 'LimitExceededException',
    CodeMismatchException = 'CodeMismatchException',
    NotAuthorizedException = 'NotAuthorizedException',
    UserNotConfirmedException = 'UserNotConfirmedException',
    UsernameExistsException = 'UsernameExistsException',
    UserNotFoundException = 'UserNotFoundException',
    AliasExistsException = 'AliasExistsException',
    ExpiredCodeException = 'ExpiredCodeException',
    InvalidPasswordException = 'InvalidPasswordException',
}

export const AwsAuthErrorMessage: Partial<{ [key in AwsAuthErrorCodes]: string }> = {
    [AwsAuthErrorCodes.LimitExceededException]: 'AWS_ERROR_LIMIT_EXCEEDED',
    [AwsAuthErrorCodes.CodeMismatchException]: 'CODE_VALIDATION_ERROR_CODE',
    [AwsAuthErrorCodes.NotAuthorizedException]: 'LOGIN_ERROR',
    [AwsAuthErrorCodes.UserNotConfirmedException]: 'AWS_ERROR_USER_NOT_CONFIRMED',
    [AwsAuthErrorCodes.UsernameExistsException]: 'SIGN_UP_USER_EXISTS',
    [AwsAuthErrorCodes.UserNotFoundException]: 'AWS_ERROR_USER_NOT_FOUND',
    [AwsAuthErrorCodes.AliasExistsException]: 'AWS_ERROR_ALIAS_EXISTS',
    [AwsAuthErrorCodes.ExpiredCodeException]: 'AWS_ERROR_EXPIRED_CODE',
};
